export enum RecommendationId {
  FOLLOW_UP = 'use_case_follow_up',
  ASK_FOR_FOLLOW = 'use_case_ask_for_follow',
  REPLY_TO_COMMENT = 'use_case_publicly_reply_to_comment',
  ANY_POST_COVERED = 'post_covered_area',
  COLLECT_EMAIL = 'use_case_collect_email',
}

export enum RecommendationType {
  TRIGGER = 'trigger_recommendation',
  USE_CASE = 'use_case_recommendation',
}
